<template>
  <span>
    <simplert
      :useRadius='true'
      :userIcon='true'
      ref='simplert'
    ></simplert>
    <i @click="openConfirm" class="mdi mdi-delete remove-button"></i>
  </span>
</template>

<script>
import Simplert from 'vue2-simplert';

export default {
  name: 'confirm-button',
  components: {
    Simplert,
  },
  props: {
    title: {
      type: String,
      default: 'Are you sure?',
    },
    message: {
      type: String,
      default: 'You will not be able to restore it!',
    },
    data: [Object, String, Number],
  },

  data() {
    return {
      isVisible: true,
    };
  },

  methods: {
    openConfirm() {
      this.$refs.simplert.openSimplert({
        title: this.title,
        message: this.message,
        customConfirmBtnText: 'Yes, delete it!',
        customCloseBtnText: 'No, keep it',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: () => this.$emit('confirm', this.data),
      });
    },
  },
};
</script>

<style scoped lang="scss">
.remove-button {
  cursor: pointer;
}
</style>

<style>
button.simplert__close {
  background-color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfirmButton.vue